import { ReactElement } from "react"

import CreateAcuDeviceForm from "../../../../components/devices/lct/acu/createAcuDeviceForm"
import PublishAcuDeviceProvider from "../../../../components/devices/lct/acu/providers/publishAcuDeviceProvider"

/** Component to publish a new air conditioning unit device */
const PublishAcuDevice = (): ReactElement => (
    <PublishAcuDeviceProvider>
        <CreateAcuDeviceForm />
    </PublishAcuDeviceProvider>
)

export default PublishAcuDevice
